import { render, staticRenderFns } from "./SkillsSequenceAdd.vue?vue&type=template&id=7880c05e&scoped=true"
import script from "./SkillsSequenceAdd.vue?vue&type=script&lang=js"
export * from "./SkillsSequenceAdd.vue?vue&type=script&lang=js"
import style0 from "./SkillsSequenceAdd.vue?vue&type=style&index=0&id=7880c05e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880c05e",
  null
  
)

export default component.exports